module.exports = __webpack_public_path__ + "img/8515a70.jpg";